import { GovernmentOfficesSettingsService } from './../../../../core/services/government-offices-settings.service';
import { Component, OnInit } from '@angular/core';
import { GovernanceSettings } from 'src/app/core/services/governance-settings.service';
import { GovernmentOfficesSettings } from 'src/app/core/services/government-offices-settings.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-villlage-governance-offices',
  templateUrl: './villlage-governance-offices.component.html',
  styleUrls: ['./villlage-governance-offices.component.scss']
})
export class VilllageGovernanceOfficesComponent implements OnInit {
    /* --------------------------------- Fields --------------------------------- */
    sections = [
      {
        id: "grampanchayat",
        title: "Gram Panchayat"
      },
      {
        id: "primary_healthcare_center",
        title: "Primary Healthcare Center"
      },
      {
        id:"anganwadi_centers",
        title: "Anganwadi centers"
      },
       /*{
        id: "postal_services",
        title: "Postal services"
      },
     {
        id: "village_exhibition_center",
        title: "Village exhibition center"
      },
     {
        id: "one_zero_four_service",
        title: "One Zero Four Service"
      },{
        id: "schools_and_institutes",
        title: "Schools and institutes"
      }, {
        id: "community_water_supplys",
        title: "Community water supplys"
      },{
        id: "sanitization",
        title: "Sanitization"
      }, {
        id: "irrigation_and_agriculture",
        title: "Irrigation and agriculture"
      },

      {
        id: "electricity_transmission",
        title: "Electricity transmission"
      }, {
        id: "civil_supplies",
        title: "Civil supplies"
      },
      {
        id: "revenue_and_land_survey",
        title: "Revenue and land survey"
      },{
        id: "law_and_order",
        title: "Law and order"
      },
      {
        id: "self_help_groups",
        title: "Self help groups"
      },

      {
        id: "milk_diaries",
        title: "Milk diaries"
      },

      {
        id: "ambulance_services",
        title: "Ambulance services"
      },
      {
        id: "telecommunications",
        title: "Telecommunications"
      },
      {
        id: "postal_services",
        title: "Postal services"
      },

      {
        id: "animal_husbandry",
        title: "Animal husbandry"
      },

      {
        id: "community_centers",
        title: "Community centers"
      }*/
    ];

    governmentOfficesSettings!: GovernmentOfficesSettings;
    lang: string = 'en';

    constructor(
      private route: ActivatedRoute,
      private governmentOfficesSettingsService: GovernmentOfficesSettingsService) { }

    ngOnInit(): void {
      this.route.queryParamMap.subscribe(queryParamMap => {
        this.lang = queryParamMap.get('lang') ?? 'en';
      });
      this.governmentOfficesSettingsService.getGovernmentOfficesSettings().subscribe(data=>{
        this.governmentOfficesSettings = data;
      })
    }

}
